export function EmptyField() {
  return <div className="h-[20px]"></div>
}

/**
 * @deprecated Only works inside schema form
 */
export default EmptyField
